import Vue from 'vue'
import axios from 'axios'

import router from '../router'
import store from '../store'

axios.defaults.withCredentials = true

// axios 配置
axios.defaults.timeout = 100000
// axios.defaults.baseURL = 'https://api.github.com';
Vue.prototype.Ajax = axios
// Add a request interceptor 请求
axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    // console.log(config)
    // Vue.prototype.$Loading.start()
    // console.log(config)
    config.headers = {Pragma: 'no-cache'}
    return config
}, function (error) {
    // Do something with request error
    return Promise.reject(error)
})
let url = ''
let testUrl= ''
switch(process.env.NODE_ENV) {
    case 'production':
        url = 'https://storlead.com/'
        testUrl = 'https://nandflashtest.storlead.com'
      break
    case 'development':
      url = 'http://sp.sp.com/'
      break
    case 'test':
        url = 'http://sp.sp.com/'
        testUrl = 'http://sp.sp.com'
        break
}
// http response 拦截器 errorCode
axios.interceptors.response.use(
    response => {
        // console.log(Vue.prototype)
        // Vue.prototype.$Loading.finish()
        let data = response.data
        // console.log(data)
        // if (data.msg && data.msg.search('未登录') !== -1) {
            // Vue.prototype.$toast.showToast(data.msg)
            // if(router.currentRoute.fullPath!='/index') {
            //     localStorage.contractName = ''
            //     window.location.href = url + 'zh-CN/user.html#/login'
            // }

        // }
        return data
    },
    error => {
        // console.error('>>>>>>>>>response>>>>>>>>>');
        // console.error(error.response);

        return Promise.reject(error)
        // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
        // return Promise.reject(error.response.data)
    }
)


const URL = process.env.NODE_ENV === 'development' ? '/web' : '/spweb'
export default {
    axios,
    Get(url, params, fn, errorFn) {
        axios.get(URL + url, {params: params}).then(fn).catch(errorFn)
    },
    Post(url, params, fn) {
        axios.post(URL + url, params).then(fn).catch(err => console.error(err))
    },
    Delete(url, params, fn) {
        axios.delete(URL + url, {params: params}).then(fn).catch(err => console.error(err))
    },
    /*get_info(fn) {
        axios.get(URL + '/user/info', {}).then(res => {
            if (!res.isSuccess) return
            let contractName = res.data.contractName, mobile = res.data.mobile
            sessionStorage.contractName = contractName || mobile
            // store.commit('contractName', contractName || mobile)
            fn(res)
        }).catch(err => console.error(err))
    },*/
    uploadImg: URL + '/file/upload_pic',    //上传图片接口
    Down(url, name, type="application/pdf") {
        axios({
            method: 'get',
            url: url,
            responseType: 'blob'
        }).then(data => {
            if (!data) return
            if (isIE) {
                var blob = new Blob([data], {type: type})
                if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                    window.navigator.msSaveOrOpenBlob(blob, name)
                }
            } else {
                let url = window.URL.createObjectURL(new Blob([data]))
                let link = document.getElementById('download')
                link.href = url
                // link.target = "_blank"
                link.setAttribute('download', name)
                link.click()
            }
        }).catch(err => console.error(err))
    }
}




// WEBPACK FOOTER //
// ./src/api/index.js